'use client';

import * as React from 'react';
import * as SwitchPrimitive from '@radix-ui/react-switch';

import { cn } from './utils';

// w-[2rem], not w-8: tailwind.config.js makes spacing key 8 = 8px (see button.tsx).
// Colours are Ink's (.ink-switch): grey track, white knob, green when on. The
// old shadcn names (bg-switch-background, bg-card) aren't Tailwind colours here,
// so the track and knob rendered invisible.
function Switch({ className, ...props }: React.ComponentProps<typeof SwitchPrimitive.Root>) {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      className={cn(
        'peer data-[state=checked]:bg-cmp-ok data-[state=unchecked]:bg-cmp-line-2 focus-visible:border-ring focus-visible:ring-ring/50 inline-flex h-[1.15rem] w-[2rem] shrink-0 items-center rounded-full border border-transparent transition-all outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50',
        className
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className={cn(
          'bg-white shadow-sm pointer-events-none block size-4 rounded-full ring-0 transition-transform data-[state=checked]:translate-x-[calc(100%-2px)] data-[state=unchecked]:translate-x-0'
        )}
      />
    </SwitchPrimitive.Root>
  );
}

export { Switch };
